/**
 * Marker shape/type keys used by markerFactory to select the correct SVG icon.
 */
export const MARKER_TYPES = {
  USER:         'user',
  HOSPITAL:     'hospital',
  SNAKE_REPORT: 'snakeReport',
  RESCUER:      'rescuer',
  SNAKE_BITE:   'snakeBite',
  EMERGENCY:    'emergency',
  CONTROL_ROOM: 'controlRoom',
};
